// Libs
import barba from './global/barba-custom';
import Barba from '@barba/core';
import { locomotive, scroll } from './global/locomotive-custom';
import Flickity from "flickity";
import gmaps from "./dot-lib/gmaps.js";

// Objects
import menu from './blocks/menu';
import scrollToTopButton from './blocks/arrow-footer';
import initAccordions from './objects/accordions';
import initDropdowns from './objects/dropdowns';
import phoneButton from './objects/phone-button';

// Helpers & Other
import isMobile from './dot-lib/isMobile';
import displayDotSignature from './dot-lib/dotSignature';

// Dev mode scripts
import grid from './dot-lib/grid';

// Flexible layouts layoutsConfig
import layoutsConfig from './flexible/index.js'

// Flexible layout specifics
import postsGridCategoryFilters from './flexible/posts-grid-category-filters';
import postsLoadMore from './flexible/posts-load-more';
import initVideoPlayers from './flexible/video-players';

const DEBUG = false

// Keep track of instances, used to destroy and relaunch scripts on page change (Barba.js compatibility)
let sliders;

window.onload = () => {

    // On Window Loaded
    launchPrograms.then(() => {
        setTimeout(() => scroll.update(), 800);
    });

    // Development mode only
    if (process.env.NODE_ENV === 'development') {

        // Set up la grille de design
        try {
            grid();
        } catch (e) {
            if (DEBUG) {
                console.log(e);
            }
        }
    }
};

const launchPrograms = new Promise(resolve => {
    // METTRE DANS LA PROMISE LES SCRIPTS A CHARGER IMPERATIVEMENT AVANT
    // L'AFFICHAGE DU SITE ====================================================

    // Barba
    try {
        barba();
    } catch (e) {
        if (DEBUG) {
            console.log(e);
        }
    }

    // Locomotive Scroll
    locomotive();

    // Spanify
    // try { spanifyxxText('.spanned'); } catch (e) { if( DEBUG ) { console.log(e); } }

    displayDotSignature();

    isMobile();

    // Objects & Flexible

    launchOrRestartScripts();

    // Barba.js compat : Destroy & relaunch scripts

    // Barba.hooks.afterLeave(() => {
    //     scroll.destroy();
    // })

    // Barba.hooks.after(async () => {
    //     // Magie
    //     // (fix pour init le scroll après chargement du contenu car sinon Locomotive déconne et on ne voit pas le
    //     // footer généralement, mais ça marche pas tout le temps)
    //     launchOrRestartScripts();
    //     setTimeout(() => {
    //         scroll.init();
    //     }, 800);
    // });

    resolve();
});

// Scripts that need to be loaded once then reloaded on page change (barba.js compatibility)
function launchOrRestartScripts () {
    sliders = initSliders();

    scrollToTopButton();
    initAccordions();
    initDropdowns();
    postsGridCategoryFilters();
    postsLoadMore();
    initVideoPlayers();
    menu();
    gmaps();
    phoneButton();
    initAppointmentWidget();
}


function initAppointmentWidget () {
    let $target = document.querySelector('.f-make-appointment__iframe');

    if ($target) {
        const script = document.createElement('script');
        script.src = "/wp-content/themes/dot-starting-theme/js/library/appointment.js";
        $target.appendChild(script);
    }
}

function initSliders () {
    let sliders = {}

    if (layoutsConfig.flickity.length > 0) {
        sliders.flickity = []

        layoutsConfig.flickity.forEach(layout => {
            const targets = document.querySelectorAll(layout.selector);

            targets.forEach(slider => {
                const containerId = '#' + slider.id;
                const sliderSelector = containerId + ' ' + layout.selector + '__slider';

                const nextBtnSelector = containerId + ' ' + layout.nextBtnSelector;
                const prevBtnSelector = containerId + ' ' + layout.prevBtnSelector;

                const sliderDOMElement = document.querySelector(sliderSelector);
                const slideIndexContainer = document.querySelector(containerId + ' #current-index');
                const slidesCount = document.querySelectorAll(containerId + ' .carousel-cell').length;

                if (sliderDOMElement) {
                    let requestId;

                    const instance = new Flickity(sliderSelector, layout.args)
                    let currentSlideIndex = 1;

                    const nextBtns = document.querySelectorAll(nextBtnSelector)
                    if (nextBtns) {
                        nextBtns.forEach(btn => {
                            btn.addEventListener('click', function () {
                                if (slideIndexContainer) {
                                    currentSlideIndex = currentSlideIndex + 1 > slidesCount ? 1 : currentSlideIndex + 1;
                                    slideIndexContainer.textContent = currentSlideIndex.toString();
                                }
                                instance.next();
                            });
                        })
                    }

                    const prevBtns = document.querySelectorAll(prevBtnSelector)
                    if (prevBtns) {
                        prevBtns.forEach(btn => {
                            btn.addEventListener('click', function () {
                                currentSlideIndex = currentSlideIndex - 1 < 1 ? slidesCount : currentSlideIndex - 1;
                                slideIndexContainer.textContent = currentSlideIndex.toString();
                                instance.previous();
                            });
                        })

                    }

                    if (instance) {
                        sliders.flickity.push({
                            instance,
                            layoutsConfig: layout,
                            containerId: containerId,
                        })
                    }

                    // Infinite sliders (autoplay and pause on hover)
                    if (layout.infinite) {
                        play();

                        // Main function that 'plays' the marquee.
                        function play () {
                            instance.x = instance.x + 1.5;
                            instance.settle(instance.x);
                            requestId = window.requestAnimationFrame(play);
                        }

                        // Main function to cancel the animation.
                        function pause () {
                            if (requestId) {
                                window.cancelAnimationFrame(requestId);
                                requestId = undefined;
                            }
                        }

                        // Pause on mouse over / focusin
                        sliderDOMElement.addEventListener('mouseover', pause, false);
                        sliderDOMElement.addEventListener('focusin', pause, false);

                        // Unpause on mouse out / focusout
                        sliderDOMElement.addEventListener('mouseout', play, false);
                        sliderDOMElement.addEventListener('focusout', play, false);
                    }
                }
            })
        })
    }
    return sliders
}
